module.exports = __webpack_public_path__ + "img/user-09.ed018c7b.jpg";